module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"filterQuantity10":"10","filterQuantity20":"20","filterQuantity50":"50","filterQuantityNull":"all","sortBySummaryDesc":"Average % descending","sortBySummaryAsc":"Average % ascending","sortByChangeDesc":"Change % (to previous range) descending","sortByChangeAsc":"Change % (to previous range) ascending"}}')
  delete Component.options._Ctor
}
